import RatesTab from './RatesTab'
export default RatesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/RatesTab/index.js